export default __webpack_public_path__ + "static/media/snow-E.cee74d4e.png";